module.exports = __webpack_public_path__ + "static/img/head.c204fd6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/head.png
// module id = QKcC
// module chunks = 1